
const  RESOURCE_TYPE_NEWPAGER			= 0;
const  RESOURCE_TYPE_JOURNAL			= 1;
const  RESOURCE_TYPE_VIDEO				= 2;
const  RESOURCE_TYPE_NEWPAGE_JOURNAL = '0,1'

export default {
  RESOURCE_TYPE_NEWPAGER,
  RESOURCE_TYPE_JOURNAL,
  RESOURCE_TYPE_VIDEO,
  RESOURCE_TYPE_NEWPAGE_JOURNAL,
}



// WEBPACK FOOTER //
// ./src/common/consts.js